import React from 'react';

import { BrowserBreakpoints } from './Breakpoints';
import { ResponsiveConsumer } from './Responsive';

export type MapBrowserToProps<TBrowserProps> = (browser: BrowserBreakpoints) => TBrowserProps;

export function withBrowser<TBrowserProps>(mapBrowserToProps: MapBrowserToProps<TBrowserProps>) {
  return function WithBrowserWrapper<
    TDefaultProps,
    P extends Partial<TBrowserProps & TDefaultProps>,
  >(Wrapped: React.ComponentType<P> & { defaultProps?: TDefaultProps }) {
    type OwnProps = Pick<P, Exclude<keyof P, keyof TBrowserProps | keyof TDefaultProps>>;
    type BrowserProps = Partial<Pick<P, keyof TBrowserProps>>;
    type DefaultProps = Partial<Pick<P, keyof TDefaultProps>>;

    const WrappedWithBrowser: React.FC<OwnProps & BrowserProps & DefaultProps> = props => (
      <ResponsiveConsumer>
        {({ browser }) => <Wrapped {...{ ...mapBrowserToProps(browser), ...props } as any} />}
      </ResponsiveConsumer>
    );
    WrappedWithBrowser.defaultProps = Wrapped.defaultProps;

    type WrappedWithBrowser = typeof WrappedWithBrowser;

    return WrappedWithBrowser as WrappedWithBrowser & { defaultProps?: TDefaultProps };
  };
}
